"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    breadcrumbClassNames: function() {
        return breadcrumbClassNames;
    },
    useBreadcrumbStyles_unstable: function() {
        return useBreadcrumbStyles_unstable;
    }
});
const _react = require("@griffel/react");
const breadcrumbClassNames = {
    root: 'fui-Breadcrumb',
    list: 'fui-Breadcrumb__list'
};
const useListClassName = /*#__PURE__*/ (0, _react.__resetStyles)("rc5rb6b", null, [
    ".rc5rb6b{list-style-type:none;display:flex;align-items:center;margin:0;padding:0;}"
]);
const useBreadcrumbStyles_unstable = (state)=>{
    'use no memo';
    const listBaseClassName = useListClassName();
    state.root.className = (0, _react.mergeClasses)(breadcrumbClassNames.root, state.root.className);
    if (state.list) {
        state.list.className = (0, _react.mergeClasses)(listBaseClassName, breadcrumbClassNames.list, state.list.className);
    }
    return state;
}; //# sourceMappingURL=useBreadcrumbStyles.styles.js.map
